import { z } from "zod";

export const meterSchema = z.object({
  meter_ndx: z.number().optional().nullable(),
  meter_id: z.string().min(1, "Meter ID is required."),
  meter_serial: z.string().min(1, "Meter serial is required."),
  meter_make: z.string().optional().nullable(),
  meter_model: z.string().optional().nullable(),
  meter_type_ndx: z
    .number({
      required_error: "Meter type is required.",
      invalid_type_error: "Meter type is required.",
    })
    .min(1, "Meter type is required."),
  unit_native_ndx: z
    .number({
      required_error: "Unit native is required.",
      invalid_type_error: "Unit native is required.",
    })
    .min(1, "Unit native is required."),
  gal_conversion_ndx: z
    .number({
      required_error: "Gallon conversion is required.",
      invalid_type_error: "Gallon conversion is required.",
    })
    .min(1, "Gallon conversion is required."),
  rollover_num: z.preprocess((value) => {
    if (value === "" || value === null || value === undefined) {
      return undefined;
    }

    const coercedValue = Number(value);
    return Number.isNaN(coercedValue) ? value : coercedValue;
  }, z.number().int().nonnegative().optional()),
  notes: z.string().optional().nullable(),
});

export const installSchema = z.object({
  well_ndx: z.number({
    required_error: "Well is required.",
    invalid_type_error: "Well is required.",
  }),
  installed_at: z.string().optional(),
  installation_note: z.string().optional().nullable(),
});

export const removeSchema = z.object({
  removed_at: z.string().optional(),
  installation_note: z.string().optional().nullable(),
});

export const transferSchema = z.object({
  to_well_ndx: z.number({
    required_error: "Target well is required.",
    invalid_type_error: "Target well is required.",
  }),
  transferred_at: z.string().optional(),
  installation_note: z.string().optional().nullable(),
});
